import { toRadians } from '@resn/gozer-math';
import { noop } from '@resn/gozer-misc';
import { gsap } from '@resn/gsap';

export class FlyUpSpinTransition {
    constructor(object, shader, animationProps) {
        this.name = 'flyUpSpin';
        this.object = object;
        this.shader = shader;
        this.animationProps = animationProps;
        this.transparent = false;
        this.tl = null;

        this.init();
    }

    setTransitionUniforms(shader) {}

    createCustomMeshes = noop;
    update = noop;

    init = () => {
        const { position, positionTarget, rotation, rotationTarget } = this.animationProps;

        position.x = positionTarget.x = 0;
        position.z = positionTarget.z = 0;
        position.y = positionTarget.y = -2;

        rotation.x = rotationTarget.x = 0;
        rotation.y = rotationTarget.y = toRadians(-360);
        rotation.z = rotationTarget.z = 0;
    };

    start = () => {
        const { positionTarget, rotationTarget } = this.animationProps;

        this.tl?.kill();
        this.tl = gsap.timeline({ delay: 0.1 }).to(
            positionTarget,
            {
                y: 0,
                duration: 1.6,
                ease: 'elastic.out(1, 0.9)',
            },
            0
        );
        this.tl.to(
            rotationTarget,
            {
                x: 0,
                y: 0,
                z: 0,
                duration: 1.6,
                ease: 'power3.out',
            },
            0.2
        );

        return this.tl;
    };

    destroy = () => {
        this.tl?.kill();
        this.tl = null;
    };

    reset = () => {
        this.tl?.kill();
        this.tl = null;
    };
}
